<div class="tw-block tw-w-full tw-h-screen tw-font-lexend tw-bg-white tw-flex tw-flex-col">
  <div class="tw-shrink-0 tw-px-4 tw-pt-4">
    <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl"
      (click)="goBack()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
      [iconName]="'arrow_back'"></cs-icon>
    </div>
  </div>
  <div class="tw-flex-1 tw-overflow-y-auto">
    @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && userLanguage === appConfig.Shared.Languages.HI) {
      <iframe src="https://cdn2.cureskin.com/html/consent/hi/IsotretinoinMale.html" class="tw-w-full tw-h-full tw-border-none"></iframe>
    }
    @if (user?.get('Gender') === appConfig.Shared.Gender.MALE && userLanguage !== appConfig.Shared.Languages.HI) {
      <iframe src="https://cdn2.cureskin.com/html/consent/en/IsotretinoinMale.html" class="tw-w-full tw-h-full tw-border-none"></iframe>
    }
    @if (user?.get('Gender') === appConfig.Shared.Gender.FEMALE && userLanguage === appConfig.Shared.Languages.HI) {
      <iframe src="https://cdn2.cureskin.com/html/consent/hi/IsotretinoinFemale.html" class="tw-w-full tw-h-full tw-border-none"></iframe>
    }
    @if (user?.get('Gender') === appConfig.Shared.Gender.FEMALE && userLanguage !== appConfig.Shared.Languages.HI) {
      <iframe src="https://cdn2.cureskin.com/html/consent/en/IsotretinoinFemale.html" class="tw-w-full tw-h-full tw-border-none"></iframe>
    }
  </div>
  <div class="tw-shrink-0 tw-bg-white tw-border-t tw-border-gray-100">
    <div class="tw-px-6 tw-pt-3 tw-pb-5">
      <div class="tw-flex tw-gap-4" [ngClass]="{'tw-opacity-80': consentPresent}">
        <span class="tw-w-1/2 tw-p-3 tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-lexend tw-text-400 tw-rounded-3"
                      [ngClass]="{
                        'tw-bg-teal-600 tw-text-white': consentGivenType === 'yes',
                        'tw-bg-gray-200 tw-text-gray-400': consentPresent && consentGivenType !== 'yes',
                        'tw-bg-white tw-border-2 tw-border-gray-300 tw-text-gray-600 tw-cursor-pointer': !consentPresent
                      }"
          (click)="onConsentClick(true)"
        i18n="@@iConsent">Yes, I Consent</span>
        <span class="tw-w-1/2 tw-p-3 tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-lexend tw-text-400 tw-rounded-3"
                      [ngClass]="{
                        'tw-bg-teal-600 tw-text-white': consentGivenType === 'no',
                        'tw-bg-gray-200 tw-text-gray-400': consentPresent && consentGivenType !== 'no',
                        'tw-bg-white tw-border-2 tw-border-gray-300 tw-text-gray-600 tw-cursor-pointer': !consentPresent
                      }"
          (click)="onConsentClick(false)"
        i18n="@@no">No</span>
      </div>
    </div>
  </div>
</div>

<pop-up [show]="showAlreadyRespondedPopup" (close)="closePopup()">
  <div class="tw-p-6 tw-text-center tw-rounded-2xl">
    <div class="tw-mb-4">
      <cs-icon class="tw-h-12 tw-w-12 tw-text-teal-600 tw-mx-auto" [iconName]="'check_circle'"></cs-icon>
    </div>
    <p class="tw-font-bold tw-font-lexend tw-text-500 tw-text-gray-800 tw-mb-2" i18n="@@responseAlreadyRecorded">Response Already Recorded</p>
    <p class="tw-font-lexend tw-text-300 tw-text-gray-500 tw-mb-5" i18n="@@consentAlreadySubmitted">You have already submitted your response for this consent form.</p>
    <span class="tw-bg-teal-600 tw-text-white tw-font-bold tw-capitalize tw-font-lexend tw-text-400 tw-py-3 tw-px-8 tw-rounded-3 tw-cursor-pointer tw-inline-block"
    (click)="closePopup()" i18n="@@okay">okay</span>
  </div>
</pop-up>
